// extracted by mini-css-extract-plugin
module.exports = {"shadow":"BaseModal_shadow__1SJyh","modal":"BaseModal_modal__39tb3"};